import canonicalModules from '../data/canonicalModules.json';
import { buildVisibleAgencyModules } from './navigationVisibility';

const isPreviewHost = (hostname = '') => hostname.includes('.preview.') || hostname === 'localhost' || hostname === '127.0.0.1';

export const isPavfDiagnosticsEnabled = () => {
  if (typeof window === 'undefined') return false;
  const override = String(window.localStorage?.getItem('pavf:diagnostics') || '').toLowerCase();
  return override === '1' || override === 'true' || isPreviewHost(window.location?.hostname || '');
};

export const buildPavfDiagnosticsSnapshot = ({ admin, permissions = [], moduleAccessKeys = [], canView, routeRules = [] }) => {
  const derivedRouteRules = routeRules.length ? routeRules : [
    { path: '/agency/dashboard', decision: 'accessible', reason: 'open-admin-surface' },
    { path: '/agency/crm/opportunities', decision: canView('crm.opportunities') ? 'accessible' : 'forbidden', reason: 'permission:crm.opportunities' },
    { path: '/agency/crm/contacts', decision: canView('crm.contacts') ? 'accessible' : 'forbidden', reason: 'permission:crm.contacts' },
    { path: '/agency/cms/pages', decision: canView('cms.pages') ? 'accessible' : 'forbidden', reason: 'permission:cms.pages' },
    { path: '/agency/reports', decision: canView('reports') ? 'accessible' : 'forbidden', reason: 'permission:reports' },
    { path: '/agency/calendar', decision: canView('calendar') ? 'accessible' : 'forbidden', reason: 'permission:calendar' },
    { path: '/agency/administration/access-control', decision: canView('administration.access_control') ? 'accessible' : 'forbidden', reason: 'permission:administration.access_control' },
  ];

  const visibleModules = buildVisibleAgencyModules({
    agencyModules: canonicalModules.rootModules,
    canView,
  });

  return {
    currentUser: {
      id: admin?.id || null,
      email: admin?.email || null,
      departmentId: admin?.department_id || null,
      primaryPositionLabel: admin?.primary_position_label || admin?.primary_position?.label || null,
      assignments: admin?.positions || [],
    },
    securityContext: {
      accessModelVersion: admin?.access_model_version || null,
      isSuperAdmin: !!admin?.is_super_admin,
      primaryPosition: admin?.primary_position || null,
    },
    effectivePermissions: [...permissions],
    moduleAccessKeys: [...moduleAccessKeys],
    navigationDecisions: visibleModules.map((module) => ({
      label: module.label,
      path: module.path,
      submodules: (module.submodules || []).map((item) => ({ label: item.label, path: item.path })),
    })),
    routeDecisions: derivedRouteRules.map((item) => ({
      path: item.path,
      decision: item.decision,
      reason: item.reason || null,
    })),
    ownershipScope: admin?.primary_position?.visibility_policy || null,
  };
};

export const publishPavfDiagnosticsToWindow = (snapshot) => {
  if (typeof window === 'undefined' || !isPavfDiagnosticsEnabled()) return snapshot;
  window.__PAVF_DIAGNOSTICS__ = snapshot;
  window.__printPAVFDiagnostics__ = () => snapshot;
  return snapshot;
};
